/**
 * 数值状态类型
 * - POSITIVE: 大于零的数值
 * - NEGATIVE: 小于零的数值
 * - ZERO: 等于零的数值
 * - NULL: 空值 (null 或 undefined)
 */
export enum NumberStatus {
  POSITIVE = "positive",
  NEGATIVE = "negative",
  ZERO = "zero",
  NULL = "null",
}

/**
 * 数值状态结果
 */
export interface NumberStatusResult {
  /** 原始值 */
  value: number | null;
  /** 数值状态 */
  status: NumberStatus;
  /** 是否为正数 */
  isPositive: boolean;
  /** 是否为负数 */
  isNegative: boolean;
  /** 是否为零 */
  isZero: boolean;
  /** 是否为空值 */
  isNull: boolean;
  /** 绝对值 */
  absValue: number;
}

/**
 * 分析数值状态
 * @param value 要分析的数值，可以是数字、字符串或null/undefined
 * @returns 数值状态结果对象
 * @example
 * const { isPositive, isZero, absValue } = numberStatus(percentage);
 */
export function numberStatus(
  value: number | string | null | undefined,
): NumberStatusResult {
  // 转换为数字类型
  const numValue = value === null || value === undefined ? null : Number(value);

  // 判断是否为空值
  const isNull = numValue === null || Number.isNaN(numValue);

  // 确定数值状态
  let status = NumberStatus.NULL;
  let absValue = 0;

  if (!isNull) {
    absValue = Math.abs(numValue!);
    if (numValue === 0) {
      status = NumberStatus.ZERO;
    } else if (numValue > 0) {
      status = NumberStatus.POSITIVE;
    } else {
      status = NumberStatus.NEGATIVE;
    }
  }

  return {
    value: isNull ? null : numValue,
    status,
    isPositive: status === NumberStatus.POSITIVE,
    isNegative: status === NumberStatus.NEGATIVE,
    isZero: status === NumberStatus.ZERO,
    isNull,
    absValue,
  };
}
